import { render, staticRenderFns } from "./ScreeningListCategorizationV2.vue?vue&type=template&id=e9924c60"
import script from "./ScreeningListCategorizationV2.vue?vue&type=script&lang=js"
export * from "./ScreeningListCategorizationV2.vue?vue&type=script&lang=js"
import style0 from "./ScreeningListCategorizationV2.vue?vue&type=style&index=0&id=e9924c60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports